<div class="page-wraper">

  <app-header1></app-header1>

  <!-- CONTENT START -->
  <div class="page-content">

    <app-slider1></app-slider1>
    
    
   
    
    

    <div class="section-full p-t30 p-b9 "
     style="background-image:url(assets/images/background/map-bg-dark2.png);">

    <div class="container">
        <!-- TITLE START -->
        <div class="section-head center wt-small-separator-outer">
        <!-- style="background-image: url('assets/images/handimg1.jpg'); background-size: 150%; background-position: center;"> -->
            <div class="wt-small-separator site-text-primary">
                
                <!-- <h5> School Mental Health Programs</h5> -->
            </div>
            <!-- <h2 class="wt-title">We Provide Best Services</h2> -->
        </div>
        <!-- TITLE END -->

    
    

        <div class="s-section">
            <div class="row justify-content-center">
              <!-- Card Component Template -->
              <div *ngFor="let card of cards" class="col-xl-4 col-lg-4 col-md-12 m-b30"    data-aos="fade-right"
              data-aos-mirror="true">
                <div class="service-icon-box-two card-color-{{card.colorClass}}">
                  <div class="service-icon-box-title">
                    <h4>{{ card.title }}</h4>
                  </div>
                  <div class="service-icon-box-content">
                    <!-- <p>{{ card.description }}</p> -->
                    <p [innerHTML]="card.description" style="text-align: justify;"></p>
                    <a [routerLink]="card.link" class="site-button-link site-text-primary" style="margin-left: 105px;">Read More</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
               



         <div class="container">
            <div class="section-head center wt-small-separator-outer">
                <div class="wt-small-separator site-text-primary">
                    
                    <h5> Our Programs</h5>
                </div>
            </div>
            <!-- TITLE END -->
    
            <div class="os-section">
             <div class="row">
               <!-- Service Boxes -->
        
              
               <div class="col-lg-4 col-md-6" data-aos="fade-left"
               data-aos-mirror="true">
                   <div class="service-icon-box-two box-color-2">
                       <div class="service-icon-box-image">
                           <img src="assets/images/save-our-planet-2024-05-17-16-58-28-utc.jpg" alt="School Mental Health Program" class="service-image">
                       </div>
                       <div class="service-icon-box-title">
                           <h4 class="wt-title">School Mental Health Program</h4>
                       </div>
                       <div id="content-box-1" class="content-box">
                           <!-- <p>What is Anxiety Disorders Treatment.</p> -->
                           <a routerLink="/school-program" class="site-button-link site-text-primary">Read More</a>
                       </div>
                   </div>
               </div>
   
               <div class="col-lg-4 col-md-6 m-b30" data-aos="fade-left"
               data-aos-mirror="true">
                   <div class="service-icon-box-two box-color-3">
                       <div class="service-icon-box-image">
                           <img src="assets/images/multi-ethnic-group-of-confident-mature-women-bondi-2023-11-27-05-34-15-utc.jpg" alt="Women Wellness Program" class="service-image">
                       </div>
                       <div class="service-icon-box-title">
                           <h4 class="wt-title">Women Wellness Program
                           </h4>
                       </div>
                       <div id="content-box-1" class="content-box">
                           <!-- <p>What is Anxiety Disorders Treatment.</p> -->
                           <a routerLink="/women-wellness" class="site-button-link site-text-primary">Read More</a>
                       </div>
                   </div>
               </div>
   
               <div class="col-lg-4 col-md-6 m-b30" data-aos="fade-left"
               data-aos-mirror="true">
                   <div class="service-icon-box-two box-color-4">
                       <div class="service-icon-box-image">
                           <img src="assets/images/origami-fun-2023-11-27-05-14-01-utc.jpg" alt="Elderly Wellness Program" class="service-image">
                       </div>
                       <div class="service-icon-box-title">
                           <h4 class="wt-title">Elderly Wellness Program</h4>
                       </div>
                       <div id="content-box-1" class="content-box">
                           <!-- <p>What is Anxiety Disorders Treatment.</p> -->
                           <a routerLink="/elderly-wellness" class="site-button-link site-text-primary">Read More</a>
                       </div>
                   </div>
               </div>
   
               
   
               
           </div>
                
              </div>
            </div>


            <div class="container m-t30">
                <div class="section-head center wt-small-separator-outer">
                    <div class="wt-small-separator site-text-primary">
                        
                        <h5> Emergency Services</h5>
                    </div>
                </div>
                <!-- TITLE END -->
        
                <div class="new-os-section">
                 <div class="row">
                   <!-- Service Boxes -->
            
                  
                   <div class="col-lg-4 col-md-4 m-b30" data-aos="fade-right"
                   data-aos-mirror="true">
                       <div class="service-icon-box-three box-color-2">
                           <div class="service-icon-box-image">
                            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 48 48"><g fill="#367c55"><path d="M19.758 32.97a1 1 0 0 1-.728-1.212L19.72 29H17a1 1 0 1 1 0-2h3.22l.81-3.242a1 1 0 1 1 1.94.485L22.28 27H25a1 1 0 1 1 0 2h-3.22l-.81 3.243a1 1 0 0 1-1.212.727"/><path fill-rule="evenodd" d="M9.014 20.138C9.402 18.869 10.59 18 11.938 18H36v-2h-7v-6h9v8.962l5.935 13.687a.995.995 0 0 1-.642 1.303l.001.004L33.5 37l1-2.5l7.092-2.122l-4.607-10.25l-4.803 13.734C31.795 37.131 30.607 38 29.26 38H7.054c-2.044 0-3.51-1.937-2.923-3.862zM6.036 34.749l4.88-13.99l.011-.037A1.05 1.05 0 0 1 11.938 20h23.673l-5.33 15.24l-.011.038a1.05 1.05 0 0 1-1.011.722H7.054c-.737 0-1.178-.663-1.018-1.25M36 12h-5v2h5z" clip-rule="evenodd"/></g></svg>                        </div>
                           <div class="service-icon-box-title">
                               <p>Emergency Services</p>
                           </div>
                         
                       </div>   
                   </div>
       
                   
                   <div class="col-lg-4 col-md-4 m-b30" data-aos="fade-right"
                   data-aos-mirror="true">
                    <div class="service-icon-box-three box-color-2">
                        <div class="service-icon-box-image">
                            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 16 16"><path fill="#367c55" d="M10.386 9.836a2.5 2.5 0 1 1 3.611.667C15.212 11.173 16 12.46 16 14v1.5a.5.5 0 1 1-1 0V14c0-1.724-1.276-3-3-3c-.91 0-1.298-.02-1.805-.122c-1.25-.254-2.333-1-3.585-2.566a.5.5 0 1 1 .78-.624c.9 1.124 1.653 1.74 2.434 2.043c.155.052.345.083.562.105m1.785.128q.125.015.251.034L12.5 10a1.5 1.5 0 1 0-.33-.036M9.78 11.97a.5.5 0 0 1 .5.5a1 1 0 0 1-.05.231c-.179.38-.23.774-.23 1.302v1.5a.5.5 0 1 1-1 0v-1.5c0-.657.072-1.186.307-1.696a.5.5 0 0 1 .473-.337M5.958 5.772a.5.5 0 0 1-.78.625L3.11 3.812a.5.5 0 1 1 .78-.624zM1 11h5.5a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5V.5A.5.5 0 0 1 .5 0h12a.5.5 0 0 1 .5.5v3a.5.5 0 1 1-1 0V1H1z"/></svg>
                        </div>
                        <div class="service-icon-box-title">
                            <p>Retrievals by team of trained professional</p>
                        </div>
                      
                    </div>
                </div>

                <div class="col-lg-4 col-md-4 m-b30" data-aos="fade-right"
                data-aos-mirror="true">
                    <div class="service-icon-box-three box-color-2">
                        <div class="service-icon-box-image">
                            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 48 48"><g fill="#367c55" fill-rule="evenodd" clip-rule="evenodd"><path d="M32.263 8.356q.045.055.083.114l.001.002l.003.005l.009.015l.032.053q.044.07.119.198a32 32 0 0 1 1.656 3.267C35.058 14.06 36 16.827 36 19.463c0 2.983-2.015 4.637-3.787 5.491a11.7 11.7 0 0 1-2.776.915A7.97 7.97 0 0 1 24 27.999a7.99 7.99 0 0 1-6.257-3.013l-.046-.004a8 8 0 0 1-.649-.086a8 8 0 0 1-1.97-.606c-.73-.34-1.506-.862-2.1-1.663c-.603-.813-.978-1.859-.978-3.164c0-2.467 1.202-5.27 2.306-7.352a36 36 0 0 1 2.206-3.619l.032-.045l.012-.019l.088-.13c.075-.107.182-.25.326-.418a7.4 7.4 0 0 1 1.32-1.195C19.502 5.821 21.372 5 24.054 5c2.675 0 4.712.817 6.084 1.643c.685.413 1.204.827 1.557 1.144a8 8 0 0 1 .55.55l.01.012l.005.005zM18.237 9.512l-.048.074l-.002.002l-.008.01l-.033.048q-.046.063-.132.19a34 34 0 0 0-1.942 3.212C14.988 15.094 14 17.522 14 19.462c0 .899.25 1.522.584 1.973c.344.462.819.8 1.339 1.042c.247.115.497.206.735.277a24 24 0 0 1-.429-2.6c-.113-1.074-.146-2.265.056-3.318c.199-1.032.668-2.141 1.742-2.718c1.429-.767 3.847-1.793 5.979-2.5c1.063-.353 2.1-.642 2.929-.774c.407-.064.825-.1 1.193-.063c.288.03.885.139 1.215.68c2.68 3.869 2.72 7.414 2.041 10.003c-.196.749-.45 1.412-.712 1.976q.333-.126.672-.288c1.45-.7 2.656-1.814 2.656-3.69c0-2.222-.81-4.686-1.668-6.654a30 30 0 0 0-1.546-3.051l-.094-.159l-.024-.025l-.011-.012a6 6 0 0 0-.298-.287a8.3 8.3 0 0 0-1.252-.918C27.99 7.683 26.305 7 24.055 7c-2.244 0-3.712.679-4.606 1.315a5.4 5.4 0 0 0-.961.867a4 4 0 0 0-.246.322zM32.346 8.47l-.848.53zm-.848.53l.765-.644zM18.743 22.894l-.075-.317a23 23 0 0 1-.45-2.63c-.104-.993-.117-1.96.032-2.733c.152-.792.43-1.175.723-1.333c1.307-.702 3.616-1.685 5.663-2.364c1.026-.34 1.942-.59 2.612-.696c.253-.04.439-.055.565-.054c2.198 3.268 2.175 6.137 1.636 8.191a10 10 0 0 1-1.053 2.517a8 8 0 0 1-.565.834l-.007.009l-.021.026l-.004.004l-.001.001a1 1 0 0 0-.224.471a5.998 5.998 0 0 1-8.83-1.926M27.98 12.78l-.026-.006z"/><path d="M17.914 28.855c-.212-.422-.473-.943-.914-.842c-5.404 1.23-11 4.782-11 8.557V42h36v-5.43c0-2.974-3.472-5.808-7.587-7.48l-.014-.027l-.005-.01l-.033.016c-1.093-.44-2.231-.8-3.361-1.056c-.503-.115-1.023.577-1.25 1.01H18zm13.489 1.321q.656.181 1.301.407c.012.342-.014.745-.07 1.157a8 8 0 0 1-.272 1.26H31a1 1 0 0 0-.894.553l-1 2A1 1 0 0 0 29 36v2a1 1 0 0 0 1 1h2v-2h-1v-.764L31.618 35h2.764L35 36.236V37h-1v2h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-.106-.447l-1-2A1 1 0 0 0 35 33h-.566a11 11 0 0 0 .248-1.608c.975.46 1.881.988 2.666 1.56C39.27 34.356 40 35.668 40 36.57V40H8v-3.43c0-.903.73-2.215 2.652-3.617c.966-.705 2.119-1.343 3.355-1.871a10.2 10.2 0 0 0 .381 2.354l.008.028a3 3 0 1 0 1.956-.444l-.044-.144a8 8 0 0 1-.235-1.136a7 7 0 0 1-.07-1.171q.005-.126.015-.224q.18-.056.36-.107l.415.786h14.164zM16 37.015c.538 0 1-.44 1-1.015c0-.574-.462-1.015-1-1.015s-1 .44-1 1.015c0 .574.462 1.015 1 1.015"/></g></svg>                        <div class="service-icon-box-title">
                            <p>Psychiatrist Consultations</p>
                        </div>
                      
                    </div>
                </div>
                    </div>
                <div class="col-lg-4 col-md-4 m-b30" data-aos="fade-left"
                data-aos-mirror="true">
                    <div class="service-icon-box-three box-color-2">
                        <div class="service-icon-box-image">
                            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 48 48"><g fill="#367c55" fill-rule="evenodd" clip-rule="evenodd"><path d="M14 24v8h8v-8zm6 6v-4h-4v4z"/><path d="M19 6a6 6 0 0 0-5.653 3.985H6v2.481l4 3.03V40H7a1 1 0 1 0 0 2h3v.015h28V42h3a1 1 0 1 0 0-2h-3V15.532l4.5-3.03V9.984H24.653A6 6 0 0 0 19 6m5.659 8A6 6 0 0 0 25 12v-.015h14.687L36.695 14zm-1.187 2A6 6 0 0 1 19 18a6 6 0 0 1-4.472-2H12v24h12V24h10v16h2V16zM13 12c0 .701.12 1.374.341 2h-2.005l-2.66-2.015H13zm7-1V9h-2v2h-2v2h2v2h2v-2h2v-2zm12 15v14h-6V26z"/></g></svg>
                        </div>
                        <div class="service-icon-box-title">
                            <p>Clinically & legally vetted protocol</p>
                        </div>
                      
                    </div>
                </div>

                <div class="col-lg-4 col-md-4 m-b30" data-aos="fade-left"
                data-aos-mirror="true">
                    <div class="service-icon-box-three box-color-2">
                        <div class="service-icon-box-image">
                          <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 48 48"><g fill="#367c55"><path d="M34.723 25.5c0 .828-.685 1.5-1.532 1.5c-.846 0-1.531-.672-1.531-1.5s.686-1.5 1.531-1.5c.847 0 1.532.672 1.532 1.5M17.362 34h4.085v-2h-4.085zm4.085 4h-4.085v-2h4.085z"/><path fill-rule="evenodd" d="M27.292 22.146c.5 0 .582-.091.741-.266c.093-.1.21-.23.45-.385a4.1 4.1 0 0 0 2.24.636l2.532-.878a3.82 3.82 0 0 0 1.388-2.2a3.7 3.7 0 0 0-.376-2.543a3.96 3.96 0 0 0-1.972-1.75a3.73 3.73 0 0 0-1.382-2.12l-2.472-.824h-.278a3.97 3.97 0 0 0-2.32-1.532L21.565 10c-.88.07-1.711.42-2.358.994a4.08 4.08 0 0 0-3.073.502a3.8 3.8 0 0 0-1.45 1.62l-2.012 1.358a3.64 3.64 0 0 0-.77 2.234c-.005.337.042.672.14.995a3.6 3.6 0 0 0-.808 2.28a3.65 3.65 0 0 0 1.072 2.572c.055.685.306 1.342.726 1.9c.42.56.99.998 1.653 1.27a5.9 5.9 0 0 1 1.89 1.793c.482.725.68 1.544.787 2.396h4.203v-3.978c0-.706.206-1.398.597-1.998q.089-.137.169-.265c.3-.478.542-.866 1.106-1.13a4.5 4.5 0 0 0 1.642-1.048a4.06 4.06 0 0 0 2.212.65m1.535-2.826l.773.495c.243.155.524.257.819.294l1.768-.613c.233-.246.389-.543.456-.858a1.72 1.72 0 0 0-.177-1.19a1.94 1.94 0 0 0-.966-.852l-.965-.4l-.232-1a1.7 1.7 0 0 0-.437-.798l-1.763-.588h-1l-.61-.848a1.9 1.9 0 0 0-.99-.702l-3.898-.258a1.96 1.96 0 0 0-1.026.468l-.79.701l-1.039-.233a2 2 0 0 0-1.523.242a1.8 1.8 0 0 0-.684.761l-.235.502l-2.154 1.455c-.139.249-.21.524-.21.802v.032q-.003.203.056.4l.3.994l-.658.813c-.243.3-.368.662-.365 1.026v.015c0 .428.17.85.494 1.177l.512.516l.059.718c.025.31.139.613.335.874c.197.263.47.475.796.608l.143.059l.133.08q.456.27.869.598c.355.273.797.672 1.37 1.388c.6.75.928 1.589 1.017 1.914h.523v-.875q0-.132-.004-.309c-.01-.574-.027-1.457.152-2.152c.215-.836.658-1.652 1.212-2.43c.555-.777 1.393-1.32 1.708-1.437s.634-.238.945-.543c.25-.244.94-.945 1.253-1.265l1.4.918c.268.175.623.273.766.3c.039-.03.16-.125.335-.254c.176-.128.866-.576 1.19-.785z" clip-rule="evenodd"/><path fill-rule="evenodd" d="M40.56 25.366s2.652 2.336 2.302 4.21s-3.803 2.39-3.803 2.39c0 7.573-7.386 7.091-11.072 6.379a19 19 0 0 1-2.042-.5v1.424s-.077.238-.314.574c-.563.797-2.029 2.142-5.515 2.142c-2.333.181-6.326-1.314-7.384-3.422v-6.449c-3.73-2.73-6.604-6.407-6.604-11.174c0-3.963 1.688-7.763 4.694-10.564S17.905 6 22.156 6a23.6 23.6 0 0 1 9.399 1.929c2.32.91 4.352 2.36 5.9 4.21c1.416 1.943 2.2 4.226 2.26 6.573c.012.54.005 1.052-.003 1.547c-.026 1.747-.05 3.286.848 5.107m-1.665 1.224l-.175-.355c-1.129-2.29-1.088-4.416-1.054-6.217c.008-.44.016-.859.007-1.257a9.7 9.7 0 0 0-1.84-5.406c-1.321-1.559-3.052-2.79-5.038-3.57l-.033-.013l-.033-.014A21.6 21.6 0 0 0 22.16 8h-.003c-3.74 0-7.31 1.386-9.925 3.824c-2.613 2.435-4.06 5.717-4.06 9.116c0 3.882 2.319 7.037 5.784 9.572l.82.6v6.87c.34.397 1.002.891 1.996 1.32c1.219.527 2.454.746 3.184.69l.08-.007h.081c2.072 0 3.049-.557 3.47-.899c.145-.117.247-.228.316-.315v-3.686l2.676.86h.003l.015.005l.086.026q.121.036.362.101c.32.085.785.199 1.345.307c1.136.22 2.584.4 3.98.31c1.419-.09 2.557-.442 3.317-1.075c.683-.569 1.33-1.589 1.33-3.652v-1.718l1.727-.258l.011-.002l.071-.013a6.7 6.7 0 0 0 1.23-.353c.343-.137.591-.28.738-.403l.053-.048a1.3 1.3 0 0 0-.09-.294a4.4 4.4 0 0 0-.555-.92a8.7 8.7 0 0 0-1-1.1l-.008-.005v-.001l-.002-.001l-.001-.002zm1.988 2.54v.002l-.003.002z" clip-rule="evenodd"/></g></svg>
                        </div>
                        <div class="service-icon-box-title">
                            <p>Compliant with Mental Healthcare Act.2017</p>
                        </div>
                      
                    </div>
                </div>

                <div class="col-lg-4 col-md-4 m-b30" data-aos="fade-left"
                data-aos-mirror="true">
                    <div class="service-icon-box-three box-color-2">
                        <div class="service-icon-box-image">
                            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 14 14"><g fill="none" stroke="#367c55" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"><path d="M5.214 1.643c0-.493.4-.893.893-.893h6.25c.493 0 .893.4.893.893v10.714c0 .493-.4.893-.893.893H9.232"/><path d="M6.553 5.438a1.563 1.563 0 1 0 3.126 0a1.563 1.563 0 1 0-3.126 0m-4.017.669h1.818a1 1 0 0 1 .707.293L7.6 8.94a1 1 0 0 0 .707.292h1.371"/><path d="M6.107 7.446L3.721 9.832a1 1 0 0 1-.707.293H.75"/><path d="m4.321 9.232l1.493 1.493a1 1 0 0 1 .293.707v1.818"/></g></svg>
                        </div>
                        <div class="service-icon-box-title">
                            <p>Walk-in emergencies</p>
                        </div>
                      
                    </div>
                </div>
                   
       
                   
               </div>
                    
                  </div>
                </div>


                <div class="container m-t30">
                    <!-- <div class="section-head center wt-small-separator-outer">
                        <div class="wt-small-separator site-text-primary">
                            
                            <h5> Emergency Services</h5>
                        </div>
                    </div> -->
                    <!-- TITLE END -->

                    
            
                    <div class="new-os-section mb-5" id="new-os-section">
                        <div class="row">

                            <div class="form-container">
                                <h4>Book Appointment</h4>
                                <p>Reach out and take the first step towards recovery.</p>
                                <br>
                                <br>
                                <form action="#" method="POST">
                                    <div class="row">
                                        <div class="col-md-6 col-12">
                                            <div class="form-group">
                                                <label>Name</label>
                                                <input type="text" class="form-control" name="name" placeholder="Name" required />
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-12">
                                            <div class="form-group">
                                                <label>Email</label>
                                                <input type="email" class="form-control" name="email" placeholder="Email ID" required />
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-12">
                                            <div class="form-group">
                                                <label>Phone</label>
                                                <input type="tel" class="form-control" name="phone" placeholder="Phone Number" required /> 
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-12">
                                            <div class="form-group">
                                                <label>Appointment Type</label>
                                                <select name="appointment_type" required class="custom-select form-select">
                                                    <option value="">Select Appointment Type</option>
                                                    <option value="consultation">Consultation</option>
                                                    <option value="therapy">Therapy</option>
                                                    <option value="follow_up">Follow-Up</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-12 col-12">
                                            <div class="btn-container">
                                                <button type="submit">Request Call Back</button>
                                            </div>
                                        </div>
                                    </div>
                                  
                                  
                                </form>
                            </div>
                        </div>
                    
                    </div>

                 <!-- Contact Form Popup -->
                 <div class="contact-popup" *ngIf="isContactFormOpen">
                    <div class="contact-popup-header">
                        <h3 class="headerget">Get in Touch</h3>
                        <span class="close-btn" (click)="closeContactForm()">&times;</span>
                    </div>
                
                    <div class="contact-form-outer">
                        <form class="cons-contact-form" [formGroup]="RegisterForm" autocomplete="off" (ngSubmit)="onSubmit()">
                            <div class="form-group">
                                <label>Name<b class="star">*</b></label>
                                <input type="text" formControlName="name" class="form-control" placeholder="Name" />
                                <div *ngIf="RegisterForm.get('name')?.invalid && RegisterForm.get('name')?.touched" class="text-danger">
                                    <span *ngIf="RegisterForm.get('name')?.errors?.required">Please Enter the Name.</span>
                                </div>
                            </div>
                
                            <div class="form-group">
                                <label>Email<b class="star">*</b></label>
                                <input type="email" formControlName="email" class="form-control" placeholder="Email" />
                                <div *ngIf="RegisterForm.get('email')?.invalid && RegisterForm.get('email')?.touched" class="text-danger">
                                    <span *ngIf="RegisterForm.get('email')?.errors?.required">Please Enter the Email.</span>
                                    <span *ngIf="RegisterForm.get('email')?.errors?.email">Please Enter a valid Email.</span>
                                </div>
                            </div>
                
                            <div class="form-group">
                                <label>Mobile<b class="star">*</b></label>
                                <input type="text" formControlName="mobile" class="form-control" placeholder="Phone" />
                                <div *ngIf="RegisterForm.get('mobile')?.invalid && RegisterForm.get('mobile')?.touched" class="text-danger">
                                    <span *ngIf="RegisterForm.get('mobile')?.errors?.required">Please Enter the Mobile.</span>
                                    <span *ngIf="RegisterForm.get('mobile')?.errors?.pattern">Enter a valid 10-digit mobile number.</span>
                                </div>
                            </div>
                
                            <div class="form-group">
                                <label>Message</label>
                                <textarea formControlName="message" class="form-control" rows="4" placeholder="Message"></textarea>
                            </div>
                
                            <!-- CAPTCHA Section -->
                            <div class="row">
                                <div class="col-lg-12 col-md-12">
                                    <div class="form-group captcha-container">
                                      <div class="captcha-actions mb-3">
                                        <label>CAPTCHA</label>
                                        <input type="text" formControlName="capicha" class="form-control" placeholder="Enter the CAPTCHA" />
                                        <div *ngIf="capicha.invalid && capicha.touched" class="text-danger">
                                          Invalid CAPTCHA
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  
                                  <div class="col-lg-12 col-md-12">
                                    <div class="captcha-display">
                                      <canvas id="captcahCanvas"></canvas>
                                      <a class="cpt-btn refresh-btn" (click)="reloadCaptcha()">&#x21bb;</a>
                                    </div>
                                  </div>
                            </div>
                            <!-- End CAPTCHA Section -->
                
                            <button type="submit" class="site-button sb-bdr-dark">Submit Now</button>
                        </form>
                    </div>
                </div>
                
                  
  

                    <!-- <div class="sticky-box" (click)="scrollToSection()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 24 24"><g fill="#367c55"><path fill="#367c55" d="M12.252 18.506a10.4 10.4 0 0 0 1.875-.302a5.2 5.2 0 0 0 2.342.151a1 1 0 0 1 .094-.007c.279 0 .645.16 1.179.497v-.554a.54.54 0 0 1 .28-.472q.349-.197.645-.443c.778-.65 1.217-1.518 1.217-2.436c0-.303-.048-.605-.143-.893a7 7 0 0 0 .564-1.359c.45.665.692 1.45.695 2.252c0 1.248-.588 2.412-1.607 3.263q-.256.213-.535.392v1.298c0 .446-.522.703-.89.437a14 14 0 0 0-1.08-.72a3 3 0 0 0-.332-.165a6.4 6.4 0 0 1-.935.069c-1.27 0-2.445-.377-3.37-1.008m-6.72-2.595C3.927 14.568 3 12.737 3 10.775c0-4.008 3.832-7.213 8.511-7.213c4.68 0 8.513 3.204 8.513 7.213s-3.833 7.212-8.513 7.212a10 10 0 0 1-1.555-.12c-.22.051-1.102.568-2.372 1.483c-.46.332-1.112.012-1.112-.547V16.59a8 8 0 0 1-.94-.68m4.455.592q.058 0 .117.009q.69.114 1.407.115c3.953 0 7.116-2.645 7.116-5.852c0-3.206-3.163-5.85-7.115-5.85s-7.117 2.644-7.117 5.85c0 1.55.74 3.01 2.046 4.103q.494.412 1.076.74a.68.68 0 0 1 .35.589v1.276c1.005-.665 1.666-.98 2.12-.98"/><path fill="url(#tokenBrandedChat1)" d="M8.062 12a1.125 1.125 0 1 0 0-2.25a1.125 1.125 0 0 0 0 2.25"/><path fill="url(#tokenBrandedChat2)" d="M11.719 12a1.125 1.125 0 1 0 0-2.25a1.125 1.125 0 0 0 0 2.25"/><path fill="url(#tokenBrandedChat3)" d="M15.375 12a1.125 1.125 0 1 0 0-2.25a1.125 1.125 0 0 0 0 2.25"/><defs><linearGradient id="tokenBrandedChat0" x1="12" x2="12" y1="3.562" y2="20.438" gradientUnits="userSpaceOnUse"><stop stop-color="#1bc9fa"/><stop offset="1" stop-color="#1778f0"/></linearGradient><linearGradient id="tokenBrandedChat1" x1="12" x2="12" y1="3.562" y2="20.438" gradientUnits="userSpaceOnUse"><stop stop-color="#1bc9fa"/><stop offset="1" stop-color="#1778f0"/></linearGradient><linearGradient id="tokenBrandedChat2" x1="12" x2="12" y1="3.562" y2="20.438" gradientUnits="userSpaceOnUse"><stop stop-color="#1bc9fa"/><stop offset="1" stop-color="#1778f0"/></linearGradient><linearGradient id="tokenBrandedChat3" x1="12" x2="12" y1="3.561" y2="20.437" gradientUnits="userSpaceOnUse"><stop stop-color="#1bc9fa"/><stop offset="1" stop-color="#1778f0"/></linearGradient></defs></g></svg>
                    </div>

                    <div class="sticky-box1" (click)="scrollToSection1()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 48 48"><path fill="#367c55" d="M26.4 33.9s4-2.6 4.8-3s1.7-.6 2.2-.2c.8.5 7.5 4.9 8.1 5.3s.8 1.5.1 2.6c-.8 1.1-4.3 5.5-5.8 5.4c-1.5 0-8.4.4-20.3-11.4C3.6 20.7 4 13.8 4 12.3s4.3-5.1 5.4-5.8c1.1-.8 2.2-.5 2.6.1s4.8 7.3 5.3 8.1c.3.5.2 1.4-.2 2.2s-3 4.8-3 4.8s.7 2.8 5 7.2c4.4 4.3 7.3 5 7.3 5"/><g fill="#3f51b5"><path d="M35 9H25v4h10c1.1 0 2 .9 2 2v10h4V15c0-3.3-2.7-6-6-6"/><path d="m28 16l-6.7-5L28 6z"/></g></svg>                    </div>
              </div>
        -->



  </div>
  <!-- CONTENT END -->

  <app-footer1></app-footer1>
  

</div>

<app-loader></app-loader>